import React from 'react';
import BuyPage from '../../components/pages/buy/index';
import PageBase from '../../components/layout/PageBase';

export class Buy extends React.Component {
  render() {
    return (
      <PageBase
        title="Torii: Home buying that's all about you"
        overrideRemarks="Expert local real estate agents meet cutting edge technology for seamless, personalized, and stress-free home buying."
        disableOverflow
      >
        <div className="page-container home-container row center-xs">
          <BuyPage />
        </div>
      </PageBase>
    );
  }
}

export default Buy;
